import gql from 'graphql-tag'

export const QUERY_GET_APP_ACTIVE_USERS = gql`
  query AppActiveUsers($metricsPeriod: MetricsPeriod!) {
    appActiveUsers(period: $metricsPeriod) {
      month
      year
      metrics {
        total_users_count
        logged_users_count
        logged_users_percent
        unlogged_users_count
        unlogged_users_percent
        date
        month
        push_campaign
      }
    }
  }
`

export const QUERY_GET_APP_ACCESSES_PER_SCREEN = gql`
  query AppAccessesPerScreen($metricsPeriod: MetricsPeriod!) {
    appAccessesPerScreen(period: $metricsPeriod) {
      month
      year
      metrics {
        screen
        access_count
      }
    }
  }
`

export const QUERY_GET_APP_ACCESSES_BY_UNIT = gql`
  query AppActiveUsersByUnit($metricsPeriod: MetricsPeriod!) {
    appActiveUsersByUnit(period: $metricsPeriod) {
      year
      month
      metrics {
        unit_users_count
        unit {
          id_erp
          name
        }
      }
    }
  }
`

export const QUERY_GET_APP_ACCESSES_BY_DAY_OF_THE_WEEK = gql`
  query AppAccessesByDayOfTheWeek($metricsPeriod: MetricsPeriod!) {
    appAccessesByDayOfTheWeek(period: $metricsPeriod) {
      year
      month
      metrics {
        access_count
        week_day
      }
    }
  }
`

export const QUERY_GET_APP_NEW_USERS_REGISTERS = gql`
  query AppNewUserRegisters($metricsPeriod: MetricsPeriod!) {
    appNewUserRegisters(period: $metricsPeriod) {
      month
      year
      metrics {
        date
        month
        registers_count
      }
    }
  }
`

export const QUERY_GET_APP_ACCESSES_BY_GENDER_AND_AGE = gql`
  query AppAccessesByGenderAndAge($metricsPeriod: MetricsPeriod!) {
    appAccessesByGenderAndAge(period: $metricsPeriod) {
      month
      year
      metrics {
        age_range
        male_count
        female_count
        unknown_gender_count
      }
    }
  }
`

export const QUERY_GET_APP_ACCESSES_BY_HOUR = gql`
  query AppAccessesByHour($metricsPeriod: MetricsPeriod!) {
    appAccessesByHour(period: $metricsPeriod) {
      month
      year
      metrics {
        access_count
        hour_time
      }
    }
  }
`

export const QUERY_GET_APP_METRICS = gql`
  query AggregatedClientStatusInfo {
    getAggregatedClientStatusInfo {
      push {
        client_active_count
        client_recent_inactive_count
        client_at_risk_count
        client_never_bought_count
        total_count
      }
    }
  }
`
